var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg403 = function Svg403(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ePBLFEM7Zx61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 289 129",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ePBLFEM7Zx63_to",
    transform: "translate(216.789,1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.990826,1.5c8.479676,0,16.341296,2.650588,22.80331,7.170288c6.647009,4.64909,11.813968,11.274689,14.650049,19.02622.131383.359095.257386.719573.378046,1.080938.377482-.041806.753932-.074917,1.128987-.099563.549485-.036108,1.104317-.054595,1.663461-.054595c6.639407,0,12.670107,2.609999,17.12509,6.861312c4.477218,4.272532,7.363535,10.202545,7.676772,16.807549.014931.314851.023897.628727.027457.940933.291993.11599.582407.236957.871112.362894c5.135869,2.240351,9.486713,5.947636,12.525964,10.592925C160.787326,68.692049,162.5,74.077278,162.5,79.863014c0,7.648838-2.993933,14.597434-7.872513,19.734087-4.894368,5.153276-11.685458,8.483362-19.25291,8.865925v0l-100.720891.036956c-9.274934-.606139-17.582037-4.77666-23.561207-11.155351C5.144092,90.998779,1.5,82.466681,1.5,73.082192c0-9.780616,3.958255-18.635403,10.358199-25.04497c6.39913-6.40875,15.239391-10.372838,25.004186-10.372838.347808,0,.694444.005024,1.03984.015006v0l1.360808.039327.170687-1.350634c1.250038-9.891462,6.113995-18.654457,13.22404-24.921722C59.681575,5.255106,68.898347,1.5,78.990826,1.5Z",
    transform: "scale(-1,1) translate(0,0)",
    fill: "#f2faff",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "ePBLFEM7Zx64_to",
    transform: "translate(179.789,53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.499,1.5l.534794.005369c5.325021.10722,10.25731,1.815049,14.334855,4.662777c4.33393,3.026786,7.70308,7.340204,9.552165,12.386864v0l.386905,1.05597l1.122089-.075392C78.783014,19.511856,79.14012,19.5,79.5,19.5c4.278321,0,8.164483,1.679151,11.035266,4.414495c2.884526,2.748438,4.744463,6.563008,4.946396,10.812004.015074.317171.020721.632808.017195.946628.296499.111289.590644.230417.882111.357372c3.323162,1.447481,6.138479,3.842929,8.105154,6.844426C106.392131,45.783834,107.5,49.262589,107.5,53c0,4.940965-1.93694,9.429563-5.093055,12.747756-3.164056,3.326543-7.553224,5.477332-12.44456,5.727679v0l-66.914021.024547c-6.026563-.397496-11.423869-3.105185-15.309672-7.244409C3.870116,60.134697,1.5,54.594152,1.5,48.5c0-6.351275,2.574363-12.101275,6.736544-16.263456s9.912181-6.736544,16.263456-6.736544c.226269,0,.451776.003263.676476.009745v0l1.360491.039249.170894-1.350286c.814938-6.439088,3.986502-12.143378,8.621963-16.223218C39.909619,3.944643,45.919354,1.5,52.5,1.5h-.001Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,58c3.049213-.666667,6.071582-1,9.067109-1s5.973156.333333,8.932891,1",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 38,
    x2: 35,
    y2: 40,
    transform: "matrix(1 0 0-1 0 78)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 38,
    x2: 65,
    y2: 40,
    transform: "matrix(-1 0 0-1 138 78)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ePBLFEM7Zx69_tr",
    transform: "translate(87.511521,50.763672) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.91716,79.277762c1.816422.661123,2.752977,2.669572,2.091853,4.485994l-1.02606,2.819078c.661124-1.816423,2.669572-2.752977,4.485994-2.091854s2.752978,2.669572,2.091854,4.485995l-5.130302,14.095389c-.06816.187267-.15064.365182-.245754.532958-2.607594,5.562496-9.079565,8.310948-14.963789,6.169266-4.085583-1.487031-6.872856-4.962139-7.666962-8.935201-.16564-.334042-.286716-.696858-.354693-1.082373l-1.736481-9.848078c-.383613-2.175577,1.069061-4.25021,3.244638-4.633823c2.048604-.361225,4.007704.905751,4.549694,2.871328.106594-.063669.215327-.125087.324966-.184792l2.929178-8.046482c.661124-1.816423,2.669572-2.752978,4.485995-2.091854s2.752978,2.669572,2.091854,4.485995l.34202-.939693c.661124-1.816422,2.669572-2.752977,4.485995-2.091853Z",
    transform: "translate(-267.913035,-104.947455)",
    fill: "#f2faff",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ePBLFEM7Zx610_to",
    transform: "translate(52.329194,69.992451)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.329194,-69.992451)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.000001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69,76.5c3.219223,0,6.208444,1.013024,8.684192,2.745143c2.561262,1.791948,4.573848,4.35178,5.728972,7.356606v0l.414007,1.076955l1.147124-.123857C85.310775,87.518516,85.653221,87.5,86,87.5c2.578214,0,4.91657,1.02702,6.6282,2.694335c1.716065,1.671635,2.802468,3.986786,2.868589,6.555851.008306.322701.000328.642229-.023133.957778.304415.111696.605891.235066.903654.369959c2.141587.970195,3.961738,2.477934,5.228015,4.342993C102.800828,104.181734,103.5,106.26206,103.5,108.5c0,2.876861-1.155318,5.492915-3.038466,7.448977-1.905364,1.979138-4.554036,3.284579-7.517501,3.514558v0l-42.86405.036397c-3.541398-.391743-6.692765-2.086343-8.956103-4.592181C38.872171,112.414787,37.5,109.117694,37.5,105.5c0-3.865993,1.567003-7.365993,4.100505-9.899495s6.033502-4.100505,9.899495-4.100505c.203177,0,.405344.004318.606416.012872v0l1.362992.057981.186654-1.351395c.539798-3.908196,2.449055-7.363185,5.214231-9.830054C61.584701,77.967827,65.125485,76.5,69,76.5Z",
    transform: "matrix(-1 0 0 1 141 0)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,109c1.694007-1.333333,3.373101-2,5.037283-2s3.31842.666667,4.962717,2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ePBLFEM7Zx614_tr",
    transform: "translate(49.461417,109.499982) rotate(-9.999988)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.61019,-94.224599)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 66,
    rx: 3,
    ry: 3,
    transform: "translate(30 41)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 32,
    transform: "translate(33 33)",
    fill: "#f2faff",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 23,
    transform: "translate(33 33)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7,
    transform: "translate(30 82)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#0d47a1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 52,
    rx: 3,
    ry: 3,
    transform: "matrix(.707107 0.707107-.707107 0.707107 49.263456 12.493951)",
    fill: "#0d47a1",
    fillRule: "evenodd"
  }))))))));
};
export { Svg403 as ReactComponent };
export default "/f3144cba85f697b1dd2950d415169f8f.svg";